import { Component, OnInit, Inject, NgModule, Input } from '@angular/core';
import { UserService } from '../../../../shared/services/user.service';
import { LoadingService } from '../../../../shared/services/loading.service';
import { Subscription } from 'rxjs/Subscription';
import { CustomerSelectItem } from '../../../setup-equipment/setup-equipment.model';
import { ManageEquipmentService } from '../../manage-equipment.service';
import { NotificationsService } from 'angular2-notifications';
import { UpdateSMUReadingModel, EquipmentSMUHistoryVM } from '../../models/manage-equipment.model';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../../app/modules/rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import moment from 'moment';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


// @NgModule({
//   providers: [
//     { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } }
//   ]
// })

@Component({
  selector: 'app-update-meter',
  templateUrl: './update-meter.component.html',
  styleUrls: ['./update-meter.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    //{ provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
})


export class UpdateMeterComponent implements OnInit {

  smuChangeTo: number;
  smuPrechange: number;
  doe: number;
  doeRChangeTo: number;
   doeFChangeTo: number;
    TotalDistance: number;
  dateOfReading: Date = new Date();
  saving: boolean = false;
  private _equipmentId: number;
  private _subscriptions: Subscription[] = [];
  customerList: CustomerSelectItem[] = [];
  selectedCustomer: number;
  IsRopeshovel:boolean;
  lastUpdateTime: Date;

  smuForm: FormGroup;
  smuReadingInput: FormControl;
  doeFReadingInput: FormControl;
  doeRReadingInput: FormControl;

  updateMeterDateControl = new FormControl(moment());

  bcmChangeTo: number;
  bcmPrechange: number;
  bcmReadingInput: FormControl;

  tonChangeTo: number;
  tonPrechange: number;
  tonReadingInput: FormControl;

  SMUHistory:EquipmentSMUHistoryVM[];
  // smuReadingInput = new FormControl('', [Validators.required]);

  maxDate = new Date();
DistanceEnabled: boolean;
  smuReadingInputValidation() {
    return this.smuChangeTo < this.smuPrechange;
  }

  inputSMUErrorMessage() {
    return this.smuReadingInput.hasError('required') ? 'You must enter a value' :
      ''
      ;
  }

  bcmReadingInputValidation() {
    return this.bcmChangeTo < this.bcmPrechange;
  }
  inputBCMErrorMessage() {
    return this.bcmReadingInput.hasError('required') ? 'You must enter a value' :
      ''
      ;
  }

  tonReadingInputValidation() {
    return this.tonChangeTo < this.tonPrechange;
  }
  inputTONErrorMessage() {
    return this.tonReadingInput.hasError('required') ? 'You must enter a value' :
      ''
      ;
  }

  constructor(
    private _loading: LoadingService,
    private _user: UserService,
    public dialogRef: MatDialogRef<UpdateMeterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _equipment: ManageEquipmentService,
    private _notification: NotificationsService,

  ) {

  }

  ngOnInit() {
    this._loading.startLoading();
    this._subscriptions.push(this._user.getCustomerList().subscribe(customers => {
      this.customerList = customers;
      this.selectedCustomer = this.data.customerId;
      this._loading.finishedLoading();
      this.lastUpdateTime = new Date(this.data.lastUpdateTime);
    }));
    this._equipmentId = this.data.equipmentId;
    this.smuPrechange = this.data.smuPrechange;
    this.IsRopeshovel=this.data.IsRopeshovel;
    this.doe = this.data.doeCurrent;
    this.bcmPrechange =this.data.bcmPrechange;
    this.tonPrechange =this.data.tonPrechange;
    this.bcmChangeTo =this.bcmPrechange;
    this.tonChangeTo=this.tonPrechange;
    this.DistanceEnabled=this.data.DistanceEnabled;
    this.createFormControls(this.smuPrechange, this.bcmPrechange, this.tonPrechange, this.doe);
    this.createForm();
    this.loadHistoryTable();
  }


  changeLateUpdateTime(lastUpdateTime: any) {
    console.log(lastUpdateTime);
    if (lastUpdateTime != undefined && lastUpdateTime instanceof Date) {
      this.lastUpdateTime = lastUpdateTime;
      console.log("dialog lastupdate time   " + this.lastUpdateTime);
    }

  }
  loadHistoryTable(){
    this._subscriptions.push(this._equipment.GetSMUReadingHistory(this._equipmentId).subscribe(result =>{
      
      this.SMUHistory = result
    }) );
  }

  createFormControls(preChangeSMU: number,preChangeBCM:number, preChangeTON:number, preDoe:number ) {
    this.smuReadingInput = new FormControl('', [
      Validators.required,
      Validators.min(preChangeSMU),
    ]);

    this.doeFReadingInput = new FormControl('', [
      Validators.required,
      //Validators.min(preDoe),
    ]);

     this.doeRReadingInput = new FormControl('', [
      Validators.required,
      //Validators.min(preDoe),
    ]);

    this.bcmReadingInput = new FormControl('', [
      //Validators.required,
      Validators.min(preChangeBCM),
    ]);

    this.tonReadingInput = new FormControl('', [
      //Validators.required,
      Validators.min(preChangeTON),
    ]);
  }
  createForm() {
    this.smuForm = new FormGroup({
      smuReadingInput: this.smuReadingInput,
      doeFReadingInput: this.doeFReadingInput,
       doeRReadingInput: this.doeRReadingInput,
      bcmReadingInput: this.bcmReadingInput,
      tonReadingInput: this.smuReadingInput,
    });
  }
    getFormatedDate = (currentDate) => {
  console.log("date", currentDate)
    let dd = currentDate.getDate();
    let mm = currentDate.getMonth() + 1; // January is 0!
    const yyyy = currentDate.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    return `${dd} ${mm} ${yyyy}`;
  };
  updateMeterClicked(): void {

    let updateModel = new UpdateSMUReadingModel();
    updateModel.currentReading = this.smuChangeTo;
    if(this.DistanceEnabled){
      updateModel.ForwardDistance= this.doeFChangeTo; 
      updateModel.ReverseDistance= this.doeRChangeTo; 
    }
    updateModel.dateReadSMU = this.getFormatedDate(new Date(this.dateOfReading));// this.getFormatedDate(this.dateOfReading);//this.dateOfReading.toDateString();
    updateModel.equipmentId = this._equipmentId;
    updateModel.bcm=this.bcmChangeTo;
    updateModel.ton =this.tonChangeTo;

    if (this.smuChangeTo == 0)
      return;
    this._loading.startLoading();
    this.saving = true;

    console.log("Update meter", updateModel)
    this._subscriptions.push(this._equipment.changeSMUReading(updateModel).subscribe(succeeded => {
      this.saving = false;
      console.log(succeeded);
      this._loading.finishedLoading();
      if (succeeded.m_Item1) {
        this._notification.success('Meter Reading updated', 'This equipment meter reading has been successfully changed to ' + updateModel.currentReading + '.');
        this.dialogRef.close(succeeded.m_Item1);
      } else {
        console.log(succeeded.m_Item2);
        this._notification.error('Error', succeeded.m_Item2);
      }
    }));



  }
calculateTotal() {
  const forward = Number(this.doeFChangeTo) || 0;
  const reverse = Number(this.doeRChangeTo) || 0;
  this.TotalDistance = forward + reverse;
}

  ngOnDestroy() {
    this._subscriptions.forEach(s => {
      if (!s.closed)
        s.unsubscribe();
    });
  }


  onNoClick(): void {
    this.dialogRef.close(false);
  }

}
